<template>
  <div>
    <img
      class="amplify-image"
      :src="url"
    />
  </div>
</template>

<script>
  export default {
    name: 'SpotS3Image',
    props: ['imagePath', 's3ImageConfig'],
    data() {
      return {
        url: null,
        error: '',
        logger: {},
      }
    },
    computed: {
      options() {
        //retain for future use
        const defaults = {}
        return Object.assign(defaults, this.s3ImageConfig || {})
      }
    },
    mounted() {
      this.getImage();
    },
    methods: {
      getImage() {
        if (!this.imagePath) {
          return this.setError('Image path not provided.')
        }
        this.$Amplify.Storage
          .get(this.imagePath, this.options)
          .then((url) => {
            this.url = url
          })
          .catch(e => this.setError(e));
      },
      setError: function (e) {
        this.error = this.$Amplify.I18n.get(e.message || e);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .amplify-image {
    width: 30%;
    margin: 0.2em;
    border-radius: 6px;
    border: 2px solid white;
    cursor: pointer;
  }

  .avatar {
    .amplify-image {
      border-radius: 50%;
    }

    &.small {
      .amplify-image {
        width: 40px;
        height: 40px;
      }

    }

    &.large {
      .amplify-image {
        width: 84px;
        height: 84px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/Pages/SpotS3Image.vue